module.exports = __webpack_public_path__ + "img/menu-burger.609b7631.svg";